module.exports = __webpack_public_path__ + "static/media/slider_porque_icon5.c00cc618.svg";